import { pgTable, uuid, timestamp, varchar, index } from 'drizzle-orm/pg-core';
import { deletionRequestStatusEnum } from '../enums/deletionRequestStatusEnum';

const schema = {
  id: uuid('id').defaultRandom().primaryKey(),
  external_id: uuid('external_id').defaultRandom().notNull().unique(),
  email: varchar('email', { length: 64 }).notNull(),
  token: varchar('token', { length: 128 }).notNull().unique(),
  status: deletionRequestStatusEnum('status').notNull().default('pending'),
  expires_at: timestamp('expires_at', { withTimezone: true, mode: 'date' }).notNull(),
  created_at: timestamp('created_at', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
  completed_at: timestamp('completed_at', { withTimezone: true, mode: 'date' }),
};

/**
 * @ignore
 */
export const dataDeletionRequests = pgTable(
  'DataDeletionRequests',
  schema,
  (table) => [
    index('deletion_request_email_idx').on(table.email),
    index('deletion_request_token_idx').on(table.token),
    index('deletion_request_status_idx').on(table.status),
  ]
);
